$(document).ready(function(){
    $("#burgermenu").click(function(){
        $("#dropmobilemenu").toggleClass("mobile-dropdownmenu");
        $("#burgermenu").toggleClass("burger-menu-close");
        $("html, body").toggleClass("body-overflow-hide");
    });

    let root = $('#has-home-portable-under').parent().css({"flex-wrap":"wrap"})
    root.append('<div id="hyperSpaceHolder"></div>')
    let holder = $('#hyperSpaceHolder')
    let home = $('#hypercam-phome')
    let business = $('#hypercam-pbusiness')
    holder.append(home)
    root.append(business)

    $('#mc-embedded-subscribe-form').on('submit', function () {
        if (mc.mce_validator.valid()) {
            $(this).parents('.mfp-content').find('form').toggleClass('hidden');
            $(this).parents('.mfp-content').find('div.hidden').toggleClass('hidden');
        }
    });
    $('.lazy-video').lazyTube({
        thumbnailCode: function (e, a, t) {
            return '<img data-src="//img.youtube.com/vi/' + a + "/" + t + '.jpg" alt="video" class="lazy lazy-hidden"/>'},
        embedCode: function(el, width, height, id, flags) {
            el.find('.button-video').toggle();
            el.toggleClass('show');
            return '<iframe src="https://www.youtube.com/embed/'+ id +'?autoplay=1"  allowfullscreen allow="autoplay"></iframe>'
        }
    });
    $('.button-video').on('click', function () {
        //$(this).toggle();
        $(this).parents('.lazy-video').find('.preview').trigger('click');
    })

    setInterval(function(){
        const lazy = document.querySelectorAll('.lazy-hidden');
        lazy.forEach(item => {
            item.classList.remove('lazy-hidden');
            item.src =  item.dataset.src;
        })
        if (lazy.length === 0) {
            clearInterval();
        }
    }, 200);
});